var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#CACACA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14883_53924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0359 7.0154C21.1605 5.89069 22.9561 5.8457 24.1345 6.88044L24.2785 7.0154L24.9856 7.7225C26.1103 8.84722 26.1553 10.6428 25.1206 11.8212L24.9856 11.9651L13.7733 23.1774C13.6143 23.3365 13.422 23.4572 13.2113 23.5315L13.0499 23.5783L8.59502 24.6064C7.91223 24.764 7.29642 24.1926 7.37494 23.5191L7.39457 23.406L8.42262 18.951C8.47319 18.7319 8.57222 18.5277 8.71158 18.353L8.82355 18.2277L20.0359 7.0154ZM19.3287 10.551L10.3392 19.5405L9.70276 22.2982L12.4605 21.6618L21.45 12.6723L19.3287 10.551ZM22.8643 8.42961C22.5038 8.06913 21.9366 8.0414 21.5443 8.34643L21.4501 8.42961L20.7429 9.13678L22.8642 11.2581L23.5714 10.5509C23.9318 10.1905 23.9596 9.62322 23.6546 9.23093L23.5714 9.13672L22.8643 8.42961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14883_53924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOff);
export default __webpack_public_path__ + "static/media/editOff.d5b122a12263dfc0158078e8dce02004.svg";
export { ForwardRef as ReactComponent };